import styled from "@mui/material/styles/styled";

import Stack from "@readai/pulse/components/Stack";

export const MoreDetails = styled(Stack)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#fafafa",
  borderRadius: "4px",
  padding: theme.spacing(2),
  minHeight: "100%",
}));
